<template>
  <div class="market-couponList-create">
    <div class="market-couponList-create-radio">
      <el-radio-group v-model="form.type" @change="onTypeChange" >
        <el-radio-button label="CashCoupon">代金券</el-radio-button>
        <el-radio-button label="PercentOff">折扣券</el-radio-button>
      </el-radio-group>
    </div>
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="150px">
      <div class="base-config">
        <el-form-item label="券来源" prop="supplier">
          <span>闰土自制</span>
        </el-form-item>
        <el-form-item label="适用对象" prop="suitObject">
          <span>内部商品</span>
        </el-form-item>
        <el-form-item label="券名称" prop="name">
          <el-input type="text" v-model="form.name" placeholder="请输入券名称"  maxLength="25"/>
        </el-form-item>
        <auth-button auth="welfare:coupon:template:read" >
          <el-form-item label="同步券中台" prop="external">
            <el-radio-group v-model="form.external" @change="onExternalChange" :disabled="isEditPage">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
         </auth-button>
        <el-form-item label="图片" prop="imageKey">
          <UploadImg name="imageKey" @getUploadFile="getUploadFile" :uploadUrl="form.imageKey" desc="建议：上传160*160jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="背景图" prop="backImgKey">
          <UploadImg name="backImgKey"  :width="325" :height="165" @getUploadFile="getUploadFile" :uploadUrl="form.backImgKey" desc="建议：传750*330jpg、png、jpeg图片" ></UploadImg>
        </el-form-item>
        <el-form-item v-if="form.type === 'CashCoupon'" label="面额" prop="amount" >
          <el-input type="text" v-model="form.amount" placeholder="请输入面额" oninput="value=value.replace(/[^.\d.]/g,'')" >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="form.type === 'PercentOff'" label="面额" prop="discount">
          <el-select v-model="form.discount" placeholder="请选择折扣" >
            <el-option v-for="item in discountData" :key="item.code" :label="item.title" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.type === 'PercentOff'" label="最多优惠金额" prop="maxAmount" >
          <el-input type="text" v-model="form.maxAmount" placeholder="请输入最多优惠金额" oninput="value=value.replace(/[^.\d.]/g,'')" >
          <template slot="append">元</template>
          </el-input>
          <span class="input-remark">（不输入代表不限制）</span>
        </el-form-item>
        <el-form-item v-if="form.external === true" label="品牌" prop="brandRefId">
          <el-select v-model="form.brandRefId" placeholder="请选择品牌" @change="onBrandChange" clearable filterable>
            <el-option v-for="item in brandData" :key="item.refId" :label="item.name" :value="item.refId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用门槛" prop="requireAmount" >
          <el-input type="text" v-model="form.requireAmount" oninput="value=value.replace(/[^\d]/g,'')" >
            <template slot="prepend">订单满</template>
            <template slot="append">元可用</template>
          </el-input>
          <span class="input-remark">（0元代表无门槛）</span>
        </el-form-item>
        <el-form-item label="用券时间" prop="effectiveType">
          <el-radio-group v-model="form.effectiveType"  :disabled="isEditPage">
            <el-radio label="Forever">长期有效</el-radio>
            <el-radio label="Fixed">固定时间</el-radio>
            <el-radio label="Unfixed">指定时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.effectiveType == 'Fixed'" label="" prop="fixedTime">
          <el-date-picker
            v-model="form.fixedTime"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
             :disabled="isEditPage"
          >
          </el-date-picker>
        </el-form-item>
        <div class="assign-day" v-if="form.effectiveType == 'Unfixed'" style="margin-left: 260px;">
          <el-form-item label="" prop="waitDays" label-width="0">
            <el-input type="text" v-model="form.waitDays" oninput="value=value.replace(/[^\d]/g,'')" :disabled="isEditPage">
              <template slot="prepend">领/发后</template>
              <template slot="append">日起</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="days" label-width="0">
            <el-input type="text" v-model="form.days" oninput="value=value.replace(/[^\d]|^0/g,'')" :disabled="isEditPage">
              <template slot="append">天内有效</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item label="关联商品" prop="skuIds" >
          <el-select  v-model="form.skuIds" placeholder="请选择关联商品" @change="v => onGoodsChange(v)" multiple collapse-tags filterable>
            <el-option v-for="item in goodsListData" :key="item.id" :label="item.productName" :value="item.id"></el-option>
          </el-select>
          <span class="input-remark">（如没看到对应商品，请确定是否拉取成功）</span>
        </el-form-item>
        <div class="good-table">
          <Table :tableThData="tableThData_good" :tableTrData="tableTrData_good" :pagination="false" >
            <template #id="{ row }">{{ row.id }}</template>
            <template #productName="{ row }">{{ row.productName }}</template>
            <template #type="{ row }">{{ row.type }}</template>
            <template #channelName="{ row }">{{ row.channelName }}</template>
            <template #typeName="{ row }">{{ row.typeName }}</template>
            <template #price="{ row }">{{ row.price }}</template>
          </Table>
        </div>
         <set-apportion
          :isAdmin="isAdmin"
          :form="form"
          :mallData="mallData"
          :shopTreeData="shopTreeData"
          ref="setapportion"
        ></set-apportion>
        <el-form-item label="发放类型" prop="issueType">
          <el-radio-group v-model="form.issueType" :disabled="true">
            <el-radio label="Auto">自动发放</el-radio>
            <el-radio label="Stock">库存发放</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用须知" prop="remark">
          <div style="border: 1px solid #ccc; margin-top: 10px;">
            <!-- 工具栏 -->
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
              style="height: 400px; overflow-y: hidden;"
              :defaultConfig="editorConfig"
              v-model="form.remark"
              @onCreated="onCreated"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Table from "@/components/Table/index";
import editor from '@/mixins/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import UploadImg from '@/components/UploadImg/index'
import {api_postDeductCouponCreate,api_getCouponDetailV2,api_putDeductCouponUpdate, api_getMarketWelfareTemplateList} from '@/api/market'
import { api_getConfig, api_postFileUpload } from "@/api/common";
import { api_getBrandSelectList } from "@/api/finance";
import setApportion from '../couponList/components/setApportion.vue'
import { getStorage } from '@/utils/index'
export default {
  name: "marketDeductionListCreate",
  components: {
    UploadImg,
    AuthButton,
    Table,
    Editor,
    Toolbar,
    setApportion
  },
  mixins: [ editor ],
  data() {
    // 校验金额
    const checkAmount = (rule, value, callback) => {
      const check = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value && !check.test(value)) {
        callback(new Error('请输入金额，最多保留两位小数'))
      } else if (value && check.test(value)||!value && rule.field == 'maxAmount') {
        callback()
      } else if(!check.test(value)){
        callback(new Error('请输入金额'))
      }else{
        callback()
      }
    }
    // 校验正整数---天数
    const checkInt = (rule, value, callback) => {
      const check = /(^[0-9]\d*$)/;
      if (!check.test(value)) {
        callback(new Error('请输入天数'))
      } else {
        callback()
      }
    }
    const checkImage = (rule, value, callback) => {
      if (!this.form.imageKey) {
        callback(new Error('请上传图片'))
      }else {
        callback()
      }
    }
    const checkBackImg = (rule, value, callback) => {
      if (!this.form.backImgKey) {
        callback(new Error('请上传背景图'))
      }else {
        callback()
      }
    }
    return {
      isAdmin: false, // 是否是超级管理员
      isEditPage: false, // 是否是编辑页面
      submitLoading: false,
      form: {
        type: 'CashCoupon',
        effectiveType: 'Forever',
        issueType: 'Auto',
        useRangeType: '',
        supplier:"Native",
        goods: [],
        suitObject: 'sku',
        external:false
      },
      rules: {
        name: [{required: true, message: '请输入券名称'}],
        imageKey: [{ validator: checkImage }],
        backImgKey: [{ validator: checkBackImg }],
        amount: [{required: true, validator: checkAmount}],
        discount: [{required: true, message: '请选择折扣'}],
        maxAmount: [{validator: checkAmount}],
        requireAmount: [{required: true, validator: checkAmount}],
        effectiveType: [{required: true, message: '请选择用券时间'}],
        useRangeType: [{required: true, message: '请选择使用范围'}],
        fixedTime: [{required: true, message: '请选择时间'}],
        days: [{required: true, validator: checkInt}],
        mallIds: [{required: true, message: '请选择指定商场'}],
        storeIds: [{required: true, message: '请选择指定店铺'}],
        issueType: [{required: true, message: '请选择发放类型'}],
      },
      brandData: [], // 品牌数据
      discountData: [], // 折扣下拉框数据
      mallData: [], // 获取商场数据
      shopTreeData: [], // 店铺级联框树形数据
      pickerOptions:{
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000 // 限制选当前时间之后的时间
        }
      },
      goodsListData: [],
      tableThData_good: [
        { prop: "id", label: "商品id", minWidth: "100", },
        { prop: "productName", label: "商品名称", minWidth: "100", },
        { prop: "type", label: "商品类型", minWidth: "80", },
        { prop: "channelName", label: "供应商", minWidth: "80", },
        { prop: "typeName", label: "品牌", minWidth: "120", },
        { prop: "price", label: "成本价", minWidth: "100", },
      ],
      tableTrData_good: [],
      USER_BUTTON_AUTH:[],
    };
  },

  created() {
    this.USER_BUTTON_AUTH = getStorage('USER_BUTTON_AUTH')
    if(this.$route.query.id){
      this.isEditPage = this.$route.query.copy != 'true'
      this.getCouponDetail()
    }else{
      this.getMarketWelfareTemplateList()
    }
    this.isAdmin = JSON.parse(localStorage.getItem('USER_INFO')).admin
    this.getConfigData() // 获取商场、店铺级联框、折扣枚举数据
    this.getBrandList() // 获取品牌列表
  },

  methods: {
    onGoodsChange (value) {
      console.log('line:345 value: ', value);
      this.tableTrData_good = this.goodsListData.filter(item => value.indexOf(item.id) >= 0)
    },
    // 权益商品列表
    async getMarketWelfareTemplateList() {
      if (this.USER_BUTTON_AUTH.indexOf('welfare:coupon:template:read') >= 0) {
        let res = await api_getMarketWelfareTemplateList()
        this.goodsListData = res
      }
    },
    // 获取商场、店铺级联框数据
    async getConfigData() {
      let {mall, storeThreeLevel, discount} = await api_getConfig(['mall', 'storeThreeLevel', 'discount'])
      this.discountData = discount
      this.mallData = mall
      this.shopTreeData = storeThreeLevel
    },

    // 获取品牌数据
    async getBrandList() {
      const res = await api_getBrandSelectList()
      this.brandData = res
    },

    // 券类型改变
    onTypeChange() {
      delete this.form.amount
      delete this.form.discount
    },

    // 获取券详情
    async getCouponDetail() {
      let res = await api_getCouponDetailV2({id: this.$route.query.id})
      this.form = {
        ...res,
        discount: res.discountCode,
        fixedTime: res.startTime ? [res.startTime, res.endTime] : [],
        useRangeType:res.useRangeType?res.useRangeType:'Generic',
      }
      await this.getMarketWelfareTemplateList()
      if(this.form.suitObject == 'sku'){
        this.onGoodsChange(this.form.skuIds)
      }
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              remark: this.form.remark == '<p><br></p>' ? '' : this.form.remark
            }
            // 上传头图
            if (this.form.imageKey && this.form.imageKey.size) {
              const { key } = await api_postFileUpload(this.form.imageKey, 'Coupon')
              params.imageKey = key
            } else if (this.$route.query.copy == 'true') {
              let key_src = params.imageKey.split('.com/')
              params.imageKey = key_src[key_src.length - 1]
            }

            // 上传背景图
            if (this.form.backImgKey && this.form.backImgKey.size) {
              const { key } = await api_postFileUpload(this.form.backImgKey, 'Coupon')
              params.backImgKey = key
            } else if (this.$route.query.copy == 'true') {
              let key_src = params.backImgKey.split('.com/')
              params.backImgKey = key_src[key_src.length - 1]
            }

            // 处理用券时间---固定时间的时间值
            if (this.form.effectiveType == 'Fixed') {
              params.startTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[0]).valueOf() : null // 券有效期-开始
              params.endTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[1]).valueOf() : null // 券有效期-结束
            }

            delete params.fixedTime
            !this.isEditPage && delete params.id
            delete params.storeCostRates
            console.log('params: ', params);
            // return
            const res = this.isEditPage ? await api_putDeductCouponUpdate(params) : await api_postDeductCouponCreate(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch (e) {
            console.log('line: 222 e: ', e);
            this.submitLoading = false
          }
        }
      })
    },
    // 是否同步券中台改变
    onExternalChange(value) {
      if (value) {
        this.form.issueType = 'Stock'
      }else{
        this.form.issueType = 'Auto'
      }
      
    },
    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 品牌下拉框改变
    onBrandChange(value) {
      console.log(value)
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-couponList-create {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .assign-day {
    display: flex;

    .el-input {
      width: 300px;
    }

    .el-form-item {
      &:last-child {
        .el-input {
          width: 200px;
          margin-left: 5px;
        }
      }
    }
  }
  .market-couponList-create-radio {
    border-bottom: 1px solid #ccc;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .base-config {
    margin-top: 20px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;
  }

  ::v-deep {
    .el-radio-group {
      .el-radio-button__inner {
        height: 34px;
        padding: 0;
        line-height: 34px;
        margin-right: 1px;
        width: 100px;
        border: 0;
      }

      .el-radio-button:first-child {
        .el-radio-button__inner {
          border-radius: 2px 0px 0 0;
        }
      }

      .el-radio-button:last-child {
        .el-radio-button__inner {
          border-radius: 0 2px 0 0;
        }
      }
    }

    .el-input,
    .el-textarea,
    .el-select {
      width: 350px;
    }

    .short.el-input {
      width: 156px;
    }

    .el-range-editor.el-input__inner {
      width: 350px;
      background: #F2F3F5;
      border: 0;

      input {
        background: #F2F3F5;
        border: 0;
      }
    }

    .el-range-editor.el-input__inner.is-active {
      width: 350px;
      background: #fff;
      border: 1px solid #05C8AF;

      input {
        background: #fff;
        border: 0;
      }
    }

    .desc {
      color: #999;
      font-size: 12px;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
    z-index: 999;
  }
  .good-table {
    margin-left: 150px;
    margin-bottom: 20px;

    .table-price-box {
      width: 400px;
      display: flex;

      .text {
        width: 40px;
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }

      // .el-form-item {
      //   background: #ccc;

      //   .el-form-item__content {
      //     display: flex !important;

      //     .text {
      //       height: 34px;
      //       line-height: 34px;
      //       margin: 0 10px;
      //     }
      //   }
      // }
    }
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
